import { render } from "./AdminAddRedEnvelope.vue?vue&type=template&id=0313c7e0"
import script from "./AdminAddRedEnvelope.vue?vue&type=script&lang=js"
export * from "./AdminAddRedEnvelope.vue?vue&type=script&lang=js"

import "./AdminAddRedEnvelope.vue?vue&type=style&index=0&id=0313c7e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__